<form [formGroup]="formGroup">
  <app-row>
    <!-- We set required=false here because required is hardcoded to true in the component itself -->
    <app-input-plus-picker
      formControlName="firstNoticedDate"
      [value]="formGroup.get('firstNoticedDate').value"
      label="First Noticed Date"
      i18n-label="@@firstNoticedDateLabel"
      [required]="false"
      [errorMessage]="formGroup.get('firstNoticedDate')?.errors"
      [touched]="formGroup.get('firstNoticedDate')?.touched">
    </app-input-plus-picker>

  </app-row>
  <app-row>
    <!--app-button-group
      label="Previous Findings (Yes/No/Unknown)"
      [options]="yesNoUnknownOptions"
      formControlName="previousFindings"
      [errorMessage]="formGroup.get('previousFindings')?.errors"
      [touched]="formGroup.get('previousFindings')?.touched"
    ></app-button-group-->

    <app-button-group
      label="Was Item Moved?"
      i18n-label="@@heroReport.wasItemMoved"
      [options]="yesNoOptions"
      formControlName="wasItemMoved"
      [errorMessage]="formGroup.get('wasItemMoved')?.errors"
      [touched]="formGroup.get('wasItemMoved')?.touched">
    </app-button-group>

    <div></div>
  </app-row>
  <app-row>

    <app-input
      label="POC Name"
      i18n-label="@@pocNameLabel"
      placeholder="Enter POC name"
      i18n-placeholder="@@enterPocNamePlaceholder"
      [touched]="formGroup.get('pocName')?.touched"
      formControlName="pocName">
    </app-input>

    <app-input
      label="POC Phone"
      i18n-label="@@pocPhoneLabel"
      placeholder="Enter POC phone"
      i18n-placeholder="@@enterPocPhonePlaceholder"
      [touched]="formGroup.get('pocPhone')?.touched"
      formControlName="pocPhone">
    </app-input>

  </app-row>
  <app-row>
    <app-button-group
      label="Liquid or Crystallization?"
      i18n-label="@@heroReport.liquidOrCrystallization"
      [options]="yesNoOptions"
      formControlName="liquidOrCrystallization"
      [errorMessage]="formGroup.get('liquidOrCrystallization')?.errors"
      [touched]="formGroup.get('liquidOrCrystallization')?.touched">
    </app-button-group>

  </app-row>

  <div class="speech-bubble" *ngIf="formGroup.get('liquidOrCrystallization')?.value === true">
    <app-button-group 
      label="Dead Animals or Foliage?" 
      i18n-label="@@heroReport.deadAnimalsOrFoliage"
      [options]="yesNoOptions"
      formControlName="deadAnimalsOrFoliage" 
      [errorMessage]="formGroup.get('deadAnimalsOrFoliage')?.errors"
      [touched]="formGroup.get('deadAnimalsOrFoliage')?.touched">
    </app-button-group>

    <app-input
      label="Casualties"
      i18n-label="@@casualtiesLabel"
      placeholder="Explain"
      i18n-placeholder="@@explainPlaceholder"
      type="textarea"
      formControlName="casualties">
    </app-input>

  </div>
</form>